import React from "react";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import { secondsToHMS } from "../utils/commons";
import {
  Box,
  Avatar,
  Chip,
  Card,
  useTheme,
  CardContent,
  Typography,
} from "@mui/material";
import { MemberSubscriptionsData } from "../services/MembersService";

export const PlaylistThumbCard = ({
  srcUrl,
  count,
  width,
}: {
  srcUrl: string;
  count: number;
  width: any;
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width,
        // paddingBottom: "56.25%", // 16:9 aspect ratio
        overflow: "hidden",
        aspectRatio: "16/9",
      }}
    >
      <Avatar
        variant="square"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        src={srcUrl}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          height: "100%",
          width: "30%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span>{count}</span>
        <PlaylistPlayIcon />
      </Box>
    </Box>
  );
};

export const VideoThumbCard = ({
  srcUrl,
  duration,
  width,
}: {
  srcUrl: string;
  duration: number;
  width: any;
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width,
        // paddingBottom: "56.25%", // 16:9 aspect ratio
        aspectRatio: "16/9",
        overflow: "hidden",
      }}
    >
      <Avatar
        variant="square"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
        src={srcUrl}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "8px",
          right: "8px",
          background: "rgba(0, 0, 0, 0.7)",
          color: "white",
          padding: "4px 8px",
          borderRadius: "4px",
          fontSize: "12px",
        }}
      >
        {secondsToHMS(duration)}
      </Box>
    </Box>
  );
};

export const SubscriptionThumbCard = ({
  srcUrl,
  width,
}: {
  srcUrl: string;
  width: any;
}) => {
  return (
    <Box
      sx={{
        position: "relative",
        width: width,
        aspectRatio: "16/9",
        overflow: "hidden",
        borderRadius: 2,
        boxShadow: 3,
        backgroundColor: "#f5f5f5",
      }}
    >
      <Avatar
        variant="square"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: 2,
        }}
        src={srcUrl}
      />

      {/* <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "white",
          padding: "8px",
          boxSizing: "border-box",
          borderRadius: "0 0 8px 8px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Chip
          icon={<StarIcon />}
          label="Premieum"
          sx={{
            backgroundColor: "gold",
            color: "black",
            fontWeight: "bold",
          }}
        />
      </Box> */}
    </Box>
  );
};

export const SubscriptionDetailCard = ({
  plan,
}: {
  plan: MemberSubscriptionsData;
}) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        width: "100%",
        marginBottom: 2,
        backgroundColor: "background.paper",
      }}
    >
      <CardContent>
        <Typography
          variant="h6"
          component="div"
          color={theme.palette.secondary.main}
        >
          {plan.subscription?.name || "N/A"}
        </Typography>
        <Typography variant="body2" color={theme.palette.info.light}>
          Started on: <b>{plan.startDate}</b>
        </Typography>
        <Typography variant="body2" color={theme.palette.info.light}>
          End Date:{" "}
          <b>
            {plan.subscription?.duration > 9999 ? "Life Time" : plan.endDate}
          </b>
        </Typography>
      </CardContent>
    </Card>
  );
};
